export default __webpack_public_path__ + "img/label.puroak.02.asset.991c6151.png";